module.exports = __webpack_public_path__ + "img/ufc4.966b4be5.png";